import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { cssVars } from '@/styles/Themes/cssVars';
import { borders } from '@/styles/Themes/Metrics';
import { radius } from '@/styles/Themes/Metrics';
import { FlexPresets } from '@/styles/Themes/Presets';

export const ContactInfoContainer = styled.div`
    width: 100%;
    margin: 0;

    ${Screen.desktop} {
        margin: 0 auto;
        padding: 0 30px;
    }
`;

export const FormWrapper = styled.div`
    display: grid;
    border-radius: ${radius.small};
    background: ${cssVars.bg_ash_dark2};
    padding: 28px 24px 4px;
    position: relative;
    grid-gap: 20px;

    ${Screen.ipad} {
        max-width: 680px;
        margin: 0 auto;
        padding: 29px 42px 10px;
    }

    ${Screen.desktop} {
        padding: 29px 56px 20px;
        grid-template: auto / 1fr 1fr;
    }
`;

export const FormContainer = styled.div`
    width: 100%;
`;

export const BottomInfo = styled.div<{ disabled: boolean }>`
    position: relative;
    ${Text.Mobile.medium.medium};
    width: 100%;

    ${Screen.desktop} {
        grid-column-start: 1;
        grid-column-end: 2;
        width: calc(200% + 24px);
    }

    > label {
        padding: 0 0 20px;
    }

    > button {
        ${(props) =>
            props.disabled
                ? `
        background: ${Palette.gray.light};
        box-shadow: none;
        cursor: not-allowed;
        &:hover {
            background: ${Palette.gray.light};
        }
        `
                : ``};
        margin: 0 auto;
        position: relative;
        top: 35px;
        width: 280px;

        ${Screen.desktop} {
            width: 250px;
        }
    }
`;

export const ServerError = styled.div`
    ${Text.Mobile.normal.semibold};
    display: flex;
    align-items: center;
    position: relative;
    background: ${cssVars.bg_lightBg_darkBg};
    border-radius: ${radius.small};
    border: ${borders.small} ${cssVars.bg_gray4_dark2};
    color: ${Palette.state.error};
    height: 33px;
    padding: 8px 15px;
    box-shadow: ${cssVars.shadow_card_default};
    width: 100%;

    ${Screen.ipad} {
        ${Text.Ipad.small.semibold};
    }

    ${Screen.desktop} {
        height: 40px;
    }
`;

/** @deprecated Used by FullDiscountWidgetForm — consider migrating */
export const FormTitle = styled.div`
    ${Text.Mobile.medium.semibold};
    color: ${cssVars.fg_gray_dark};
    margin: 0 0 7px;

    ${Screen.desktop} {
        ${Text.Desktop.medium.semibold};
        margin: 0 0 11px;
    }
`;

/** @deprecated Used by FullDiscountWidgetForm — consider migrating */
export const FormInput = styled.input<{ isError?: boolean }>`
    ${FlexPresets.flexRowCenter};
    border: ${borders.small}
        ${({ isError }) => (isError ? Palette.state.error : cssVars.fg_gray3_dark1)};
    border-radius: ${radius.large};
    background: ${cssVars.bg_white_dark3};
    color: ${cssVars.fg_gray2_gray3};
    padding: 0px 25px 0px 20px;
    width: 100%;
    height: 40px;
    outline: none;
    ${Text.Full.large.medium};

    ${Screen.desktop} {
        height: 50px;
    }
`;

/** @deprecated Used by FullDiscountWidgetForm — consider migrating */
export const RedStar = styled.span`
    color: ${Palette.state.error};
    padding-right: 3px;
`;

/** @deprecated Used by FullDiscountWidgetForm — consider migrating */
export const ErrorText = styled.div`
    ${Text.Mobile.normal.semibold};
    display: flex;
    align-items: center;
    position: absolute;
    background: ${cssVars.bg_lightBg_darkBg};
    border-radius: ${radius.small};
    border: ${borders.small} ${cssVars.bg_gray4_dark2};
    color: ${Palette.state.error};
    height: 33px;
    top: 47px;
    padding: 8px 15px;
    box-shadow: ${cssVars.shadow_card_default};
    width: 100%;
    z-index: 1;

    ${Screen.ipad} {
        ${Text.Ipad.small.semibold};
    }

    ${Screen.desktop} {
        height: 40px;
        top: 58px;
    }

    &:before {
        content: '';
        height: 8px;
        width: 8px;
        border-top: ${borders.small} ${cssVars.bg_gray4_dark2};
        border-right: ${borders.small} ${cssVars.bg_gray4_dark2};
        background: ${cssVars.bg_lightBg_darkBg};
        border-left: none;
        border-bottom: none;
        transform: rotate(-45deg);
        position: absolute;
        top: -6px;
        left: 30px;
    }
`;

/** @deprecated Used by FullDiscountWidgetForm — consider migrating */
export const FormInputRow = styled.div`
    position: relative;
`;
